// extracted by mini-css-extract-plugin
export default {"recos":"Q5-z","productCardOverride":"R5-z","rowHasBadge":"S5-z"};